import { FC, useMemo, useRef, useState } from "react";
import Player, { APITypes, MediaType, PlayerProps } from "@/components/Player";
import styles from "./OrientationVideoPlayer.module.scss";

const OrientationVideoPlayer: FC<
  Omit<PlayerProps, "source"> & {
    onVideoWatched: () => void;
    onProgressUpdate: (progresss: number) => void;
    orientationVideoUrls: {
      poster: string;
      "video/original": string;
      "video/480"?: string;
      "video/720"?: string;
      "video/1080"?: string;
    };
    onVideoCompleted?: () => {};
  }
> = ({
  orientationVideoUrls,
  onVideoWatched,
  onProgressUpdate,
  onVideoCompleted,
  ...props
}) => {
  const [isWatched, setIsWatched] = useState<boolean>(false);
  const [isCompleted, setIsCompleted] = useState<boolean>(false);
  const [progress, setProgress] = useState<number>(0);
  const playerRef = useRef<APITypes | null>(null);

  const onTimeUpdate = (plyr: Plyr.PlyrEvent) => {
    const currentTime = plyr.detail?.plyr.currentTime;
    const duration = plyr.detail?.plyr.duration;
    const currentPercentage = (currentTime || 0) / (duration || 1);
    if (currentPercentage > 0.9 && !isWatched) {
      setIsWatched(true);
      onVideoWatched();
    }
    if (currentPercentage === 1 && !isCompleted) {
      setIsCompleted(true);
      onVideoCompleted?.();
    }
    const stepPercentage = Math.floor(currentPercentage * 10);
    if (progress < stepPercentage) {
      onProgressUpdate(stepPercentage / 10);
      setProgress(stepPercentage);
    }
  };

  const source = useMemo(() => {
    if (
      !orientationVideoUrls?.["video/1080"] &&
      !orientationVideoUrls?.["video/720"]
    ) {
      return {
        type: "video" as MediaType,
        sources: [
          // {
          //   type: "video/webm",
          //   src: signedUrlData?.["video/webm"] || "",
          // },
          {
            type: "video/mp4",
            src:
              orientationVideoUrls?.["video/original"]?.replace(
                "http://",
                "https://"
              ) || "",
          },
          {
            type: "video/webm",
            src: orientationVideoUrls?.["video/original"] || "",
          },
          // {
          //   type: "video/ogg",
          //   src: orientationVideoUrls?.["video/480"] || "",
          // },
        ],
        poster: orientationVideoUrls?.poster || "",
      };
    }
    return {
      type: "video" as MediaType,
      sources: [
        // {
        //   type: "video/webm",
        //   src: signedUrlData?.["video/webm"] || "",
        // },
        {
          type: "video/mp4",
          src:
            orientationVideoUrls?.["video/1080"]?.replace(
              "http://",
              "https://"
            ) || "",
        },
        {
          type: "video/webm",
          src: orientationVideoUrls?.["video/720"] || "",
        },
        // {
        //   type: "video/ogg",
        //   src: orientationVideoUrls?.["video/480"] || "",
        // },
      ],
      poster: orientationVideoUrls?.poster || "",
    };
  }, [orientationVideoUrls]);

  return (
    <div className={styles.root}>
      <Player
        {...props}
        ref={playerRef}
        poster={orientationVideoUrls?.poster}
        onTimeUpdate={onTimeUpdate}
        source={source}
      />
    </div>
  );
};

export default OrientationVideoPlayer;
